/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/ai-coach-platform';

const styles = {
  footer: css`
    padding: var(--cds-spacing-200);
  `,
};

export const SearchFooter = (): React.ReactElement => {
  return (
    <Typography2 component="p" variant="bodySecondary" color="supportText" css={styles.footer}>
      {_t('#{coachLabel} is powered by AI, check for mistakes.', { coachLabel: 'Coach' })}
    </Typography2>
  );
};

export default SearchFooter;
